(function() {
  let loading = false;

  function isSoldOut(item) {
    // Spotlight usa .card__badge con un span.badge para productos agotados
    const badge = item.querySelector('.card__badge .badge');
    if (badge) return true;
    return false;
  }

  function reorderGrid() {
    const grid = document.querySelector('#product-grid');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('.grid__item'));
    const available = items.filter(item => !isSoldOut(item));
    const soldOut = items.filter(item => isSoldOut(item));

    available.forEach(item => grid.appendChild(item));
    soldOut.forEach(item => grid.appendChild(item));
  }

  function getNextPageUrl() {
    const nextBtn = document.querySelector('.pagination__item--prev');
    if (nextBtn) return nextBtn.getAttribute('href');
    return null;
  }

  function loadMoreProducts() {
    const nextUrl = getNextPageUrl();
    if (!nextUrl || loading) return;

    loading = true;

    fetch(nextUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newItems = doc.querySelectorAll('#product-grid .grid__item');
        const grid = document.querySelector('#product-grid');
        const pagination = document.querySelector('.pagination-wrapper');

        newItems.forEach(item => grid.appendChild(item));

        const newPagination = doc.querySelector('.pagination-wrapper');
        if (newPagination) {
          pagination.replaceWith(newPagination);
        } else {
          pagination.remove();
        }

        reorderGrid();
        loading = false;
      });
  }

  document.addEventListener('DOMContentLoaded', reorderGrid);

  window.addEventListener('scroll', () => {
    const pagination = document.querySelector('.pagination-wrapper');
    if (!pagination) return;
    const rect = pagination.getBoundingClientRect();
    if (rect.top < window.innerHeight + 300) {
      loadMoreProducts();
    }
  });
})();
